export default __webpack_public_path__ + "static/media/women_banner.d64080f9.jpg";